// extracted by mini-css-extract-plugin
export default {"content":"DeleteStep_content__TObC-","buttons":"DeleteStep_buttons__9YnRm"};